import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Paper } from "@mui/material";

// Define the columns for the table
const columns = [
  { field: "userEmail", headerName: "Email", flex: 1 , minWidth: 150 },
  { field: "leaveReason", headerName: "Leave Reason", flex: 1 , minWidth: 150},
  { field: "startDate", headerName: "Start Date", flex: 1 , minWidth: 150},
  { field: "endDate", headerName: "End Date", flex: 1 ,minWidth: 150},
  { field: "status", headerName: "Status", flex: 1 , minWidth: 150},
];

export default function EmployeesOnLeaveTable() {
  const [rows, setRows] = useState([]);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    const fetchEmployeesOnLeave = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/EmployeesOnLeaveThisWeek`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        const data = await response.json();

        // Check if data is available and format it
        if (data.status === "200" && Array.isArray(data.data)) {
          const rowsWithId = data.data.map((leave, index) => ({
            id: index + 1,
            userEmail: leave.userEmail,
            leaveReason: leave.leaveReason,
            startDate: leave.startDate,
            endDate: leave.endDate,
            status: leave.status,
          }));

          // Set the rows state with formatted data
          setRows(rowsWithId);
        }
      } catch (error) {
        console.error("Error fetching employees on leave:", error);
      }
    };

    fetchEmployeesOnLeave();
  }, []);

  return (
    <Box p={0}>
      <Typography variant="h5" gutterBottom>
        Employees on Leave This Week  [ {rows.length} ]
      </Typography>
      <Paper elevation={3} sx={{ padding: 0 }}>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5} // Optional: Set number of rows per page
            sx={{
              fontSize: "14px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgb(100, 95, 95)",
                color: "white",
              },
              "& .MuiDataGrid-cell": { textAlign: "center" },
            }}
          />
        </div>
      </Paper>
    </Box>
  );
}
